import api from 'utils/api';
import firebase from 'utils/auth/firebase';
import { MediaKeyError, extractMediaKeyErrorMessage, isMediaKeyError } from './media.errors';

export { MediaKeyError, isMediaKeyError } from './media.errors';

/**
 * Calls api/assets/<id>/download/.
 * Rejects with a `MediaKeyError` when the endpoint returns a user facing message
 * (e.g. "your loan expired"), so callers can display it instead of failing silently.
 */
export const getMediaKey = async (url) => {
  const userId = await firebase?.auth()?.currentUser?.uid;

  try {
    const response = await api.get(`${url}?user_id=${userId}`);
    const data = response?.data ?? {};
    const message = extractMediaKeyErrorMessage(data);

    if (message && !data.key) {
      throw new MediaKeyError(message);
    }

    return data;
  } catch (error) {
    if (isMediaKeyError(error)) {
      throw error;
    }

    const message = extractMediaKeyErrorMessage(error?.response?.data);
    throw message ? new MediaKeyError(message) : error;
  }
};
